import React, { FC, ReactElement, useCallback } from 'react';

// import { Toggle, ToggleScale } from '@pp/core/src/components/controls/toggle/Toggle';
import { Tooltip } from '@pp/core/src/components/tooltip/Tooltip';
import { useIsLargerThanExtraWide } from '@pp/core/src/styles/hooks/media';

import { Bets } from '../../config/bets';
import { useGameDispatch } from '../../store/GameStore';
import { useAutoCashoutSlice } from '../../store/slices/autocashout/selectors';
import { autoCashoutActions } from '../../store/slices/autocashout/slice';
import { Toggle, ToggleScale } from '../toggle/Toggle';

import styles from './AutoCashoutConnected.module.css';

interface AutoCashoutControlConnectedProps {
  betCode: Bets;
  isDisabled: boolean;
}
export const AutoCashoutControlConnected: FC<AutoCashoutControlConnectedProps> = ({
  betCode,
  isDisabled,
}): ReactElement => {
  const dispatch = useGameDispatch();
  const isEnabled = useAutoCashoutSlice.isEnabled(betCode);
  const isLargerThanExtraWide = useIsLargerThanExtraWide();
  const handleOnChange = useCallback(() => {
    dispatch(autoCashoutActions.toggleAutoCashout(betCode));
  }, [betCode, dispatch]);
  return (
    <div className={styles.auto_cashout_toggle}>
      <Tooltip text={!isEnabled ? 'TURN_ON' : 'TURN_OFF'} disabled={isDisabled}>
        <Toggle
          checked={isEnabled}
          onChange={handleOnChange}
          disabled={isDisabled}
          scale={isLargerThanExtraWide ? ToggleScale.Large : ToggleScale.Medium}
          showIcon={false}
        />
      </Tooltip>
    </div>
  );
};
